import { createContext, type FC, type PropsWithChildren, useEffect, useState } from 'react'

import { useFeatureFlagsQuery } from 'STORE/endpoints/featureFlags'
import { type FeatureFlagResponse } from 'TYPES/api'
import { BrowserStorage } from 'UTILS/browserStorage'

import { convertFeatureFlagResponseToFeatureFlagObject } from '../utils/convertFeatureFlagResponseToFeatureFlagObject'

export type FeatureFlags = Record<string, FeatureFlagResponse>
const sessionStorageService = new BrowserStorage(window.sessionStorage)
const FEATURE_FLAGS = 'featureFlags'

export const FeatureFlagsContext = createContext<FeatureFlags>({})

export const FeatureFlagsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({})

  const storedFlags = sessionStorageService.getItem(FEATURE_FLAGS)
  const { data } = useFeatureFlagsQuery(undefined, { skip: !!storedFlags })

  useEffect(() => {
    if (storedFlags) {
      setFeatureFlags(storedFlags)
    } else if (data) {
      const featureFlagObject = convertFeatureFlagResponseToFeatureFlagObject(data)
      sessionStorageService.setItem(FEATURE_FLAGS, featureFlagObject)
      setFeatureFlags(featureFlagObject)
    }
  }, [data])

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
  )
}
